import type { MouseEvent } from 'react'
import { MessageCircle } from 'lucide-react'
import { Button, Tooltip } from '@highlight/ui'

interface MiniAskButtonProps {
  isOpen: boolean
  onToggle: () => void
}

export function MiniAskButton({ isOpen, onToggle }: MiniAskButtonProps) {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
    onToggle()
  }

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <Button
            variant="ghost"
            size="md"
            shape="square"
            aria-label="Ask Highlight"
            aria-expanded={isOpen}
            // Don't pull focus from the open input, or its blur would close it before the toggle runs
            onMouseDown={(event) => event.preventDefault()}
            onClick={handleClick}
          />
        }
      >
        <MessageCircle aria-hidden="true" className="size-4" />
      </Tooltip.Trigger>
      <Tooltip.Content sideOffset={14}>Ask Highlight</Tooltip.Content>
    </Tooltip>
  )
}
